import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-sign-up" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger mb-5"
}
const _hoisted_4 = { class: "text-sm text-center" }
const _hoisted_5 = { class: "s10_mobile container-full-2" }
const _hoisted_6 = { class: "form-field-floating xl reactive active my-5" }
const _hoisted_7 = { class: "form-field-split active my-5" }
const _hoisted_8 = { class: "form-field-floating xl reactive half" }
const _hoisted_9 = { class: "form-field-floating xl reactive half" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "s20 form",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _cache[15] || (_cache[15] = _createStaticVNode("<a href=\"#\" data-v-5dd564a7><div class=\"text-center mb-8\" data-v-5dd564a7><img src=\"/public/images/logo-wide.svg\" class=\"auth-logo2\" data-v-5dd564a7></div></a><h2 class=\"font-semibold mt-5 mb-4 text-center\" data-v-5dd564a7>Définir votre quotité cessible</h2><p class=\"text-read text-grey-600 text-center pb-5\" data-v-5dd564a7> La quotité cessible est le montant maximum que vous pouvez utiliser mensuellement. </p>", 3)),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-engagement.svg",
              class: "size-l",
              alt: ""
            }),
            _createTextVNode(" Quotité cessible ")
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              name: "salaire_brut",
              id: "salaire_brut",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.salaireBrut) = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.calculateQuotiteCessible && _ctx.calculateQuotiteCessible(...args))),
              placeholder: "",
              readonly: ""
            }, null, 544), [
              [_vModelText, _ctx.formData.salaireBrut]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "salaire_brut" }, [
              _createTextVNode("Salaire brut "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1)),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "F CFA", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "quotite_cessible",
                id: "quotite_cessible",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.quotiteCessible) = $event)),
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.calculateQuotiteCessibleValue && _ctx.calculateQuotiteCessibleValue(...args))),
                placeholder: ""
              }, null, 544), [
                [_vModelText, _ctx.formData.quotiteCessible]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "quotite_cessible" }, [
                _createTextVNode("Quotité cessible max "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1)),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "" }, "%", -1))
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "hr" }, null, -1)),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "quotite_cessible_val",
                id: "quotite_cessible_val",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.quotiteCessibleVal) = $event)),
                readonly: "",
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.quotiteCessibleVal]
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "quotite_cessible_val" }, [
                _createTextVNode("Valeur "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1)),
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "" }, "F CFA", -1))
            ])
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "btn lg w-100 flex-center mt-8 mb-7",
            disabled: _ctx.isSubmitting
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("img", {
              src: "/public/icons/icon-valider.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Enregistrement en cours...' : 'Continuer vers le KYC'), 1)
          ], 8, _hoisted_10)
        ])
      ], 32)
    ])
  ]))
}